export const PAGES = {
  EVENT: 'event',
  ACADEMY: 'academy',
  DSML: 'dsml',
  AIML: 'ai_ml',
  COMPLETED_EVENT: 'completed_event',
  EVENT_TY_PAGE: 'event_ty_page',
};

export const BLOCKED_EXIT_PAGES = [
  'events',
  'course_page',
  'neovarsity',
];

const DEFAULT_PROGRAM = 'academy';
const REQUEST_CALLBACK_STRIP = 'request-callback-strip';


export const RCB_EXIT_INTENT_FORM_CTAS = [
  ['why-ai-rcb-cta', 'rcb', DEFAULT_PROGRAM, 'rcb_exit_intent_why_ai_section'],
  ['data-science-banner-request-callback', 'rcb', 'data_science',
    'rcb_landing_page_banner_modal'],
  ['rcb-header-strip-action', 'rcb', DEFAULT_PROGRAM, 'header_rcb_strip_modal'],
  ['navbar-request-callback', 'rcb', 'landing',
    'navbar_rcb_cta_modal'],
  ['contact-us-widget', 'rcb', DEFAULT_PROGRAM, 'rcb_widget_modal'],
  [`${REQUEST_CALLBACK_STRIP}-action`, 'rcb', DEFAULT_PROGRAM, 'rcb_new_strip'],
  ['devops-request-callback', 'rcb', 'devops',
    'devops_landing_page_cta_modal'],
  ['aiml-request-callback', 'rcb', 'ai_ml',
    'aiml_landing_page_cta_modal'],
  ['pricing-section-request-callback',
    'rcb', DEFAULT_PROGRAM, 'pricing_banner_rcb_cta_modal'],
];

export const EVENTS_FORM_VARIANTS = {
  DEFAULT: [
    'default_form_v1',
    'default_form_v2',
    'default_form_v3',
    'dynamic_default_form',
  ],
  UNIFIED_AUTH: ['unified_auth_form_v2', 'unified_auth_form_v3'],
};

export const EVENTS_FORM_IDS = {
  DEFAULT: 'application-form',
  UNIFIED_AUTH: 'unified-auth-form',
};
